import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../openapi';

@Pipe({
  name: 'applicationSubjectLabel',
  standalone: true
})
export class ApplicationSubjectLabelPipe implements PipeTransform {
  transform(application?: ApplicationAppEntityApplicationRead | null): string {
    switch (true) {
      case application?.service?.url === '/zajecie-pasa-prowadzenie-robot': {
        return 'Ulica, której dotyczy zajęcie pasa';
      }
      case application?.service?.url === '/umieszczenie-reklamy': {
        return 'Wniosek o';
      }
      case application?.service?.url === '/zezwolenie-przejazdy-pojazdow-nienormatywnych': {
        return 'Wniosek dotyczy zezwolenia'
      }
      default: {
        return 'Wniosek dotyczy';
      }
    }
  }
}
